import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { FaWifi, FaSnowflake, FaCocktail, FaBed, FaTv, FaConciergeBell } from 'react-icons/fa';

const getAmenityIcon = (amenity) => {
  switch (amenity.toLowerCase()) {
    case 'wifi': return <FaWifi />;
    case 'ac': return <FaSnowflake />;
    case 'tv': return <FaTv />;
    case 'balcony': return <FaBed />;
    case 'living area': return <FaBed />;
    case 'extra bed': return <FaBed />;
    case '1 king bed':
    case '1 twin bed':
    case '2 twin beds':
    case '1 twin bed + 1 king bed':
    case '2 king beds':
      return <FaBed />;
    default: return <FaConciergeBell />;
  }
};

const RoomCard = ({ room }) => {
  return (
    <motion.div
      className="bg-background rounded-xl shadow-xl overflow-hidden hover:shadow-2xl transition-shadow duration-300"
      whileHover={{ y: -10 }}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
    >
      <div className="relative">
        <img src={room.image} alt={room.name} className="w-full h-48 object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent"></div>
        <div className="absolute bottom-4 left-4 text-white">
          <h3 className="text-xl font-serif font-bold">{room.name}</h3>
          <p className="text-lg font-semibold">${room.price} <span className="text-sm font-normal">per night</span></p>
        </div>
      </div>
      <div className="p-6">
        <div className="flex flex-wrap gap-2 mb-4">
          {room.amenities.map((amenity, index) => (
            <motion.div
              key={index}
              className="flex items-center bg-highlight rounded-full px-3 py-1 text-sm text-secondary"
              whileHover={{ scale: 1.1 }}
            >
              {getAmenityIcon(amenity)}
              <span className="ml-1">{amenity}</span>
            </motion.div>
          ))}
        </div>
        <motion.div whileHover={{ scale: 1.05 }} whileTap={{ scale: 0.95 }}>
          <Link
            to={`/rooms/${room.id}`}
            className="inline-block bg-accent hover:bg-accent/90 text-primary font-serif font-semibold py-3 px-6 rounded-full transition-colors duration-300 shadow-lg hover:shadow-xl"
          >
            View Details
          </Link>
        </motion.div>
      </div>
    </motion.div>
  );
};

export default RoomCard;